<template>
	<div class="shop-addr-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :gtype="0" />
		
		<!-- ====== 面包屑导航 ====== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn">
			<div class="breadcrumb-left">
				<span class="bc-label">{{$t('shopSuss.t1')}}</span>
				<span class="bc-item">{{$t('shopSuss.t2')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30841_3727/11.svg')"></el-image>
				<span class="bc-item">{{$t('shopOrder.t11')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30841_3727/12.svg')"></el-image>
				<span class="bc-item bc-active">{{$t('shopOrder.t15')}}</span>
			</div>
			<div class="breadcrumb-right" @click="back()">
				<span class="bc-back-text">{{$t('shopSuss.t4')}}</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30841_3727/13.svg')"></el-image>
			</div>
		</div>

		<!-- 详情卡片主体 -->
		<div class="fd-body">
			<div class="detail-card animate__animated animate__fadeInUp">
				<!-- 渠道信息栏 -->
				<div class="channel-info-bar">
					<div class="channel-name">{{$t('indexFMsg.t27')}}</div>
					<div class="info-grid">
						<div class="l">
							<div class="info-item">
								<span class="info-label">{{$t('indexFMsg.t6')}}</span>
								<span class="info-value">{{pmsg.deliveryTime}}</span>
							</div>
							<!-- <div class="info-item">
								<span class="info-label">{{$t('indexFMsg.t7')}}</span>
								<span class="info-value">22</span>
							</div> -->
						</div>
						<div class="l">
							<div class="info-item">
								<span class="info-label">{{$t('indexFMsg.t8')}}</span>
								<span class="info-value" v-if="pmsg.calculatePriceMode==1">{{$t('indexFMsg.t9')}}</span>
								<span class="info-value" v-if="pmsg.calculatePriceMode==2">{{$t('indexFMsg.t10')}}</span>
								<span class="info-value" v-if="pmsg.calculatePriceMode==3">{{$t('indexFMsg.t11')}}</span>
								<span class="info-value" v-if="pmsg.calculatePriceMode==4">{{$t('indexFMsg.t12')}}</span>
							</div>
							<!-- <div class="info-item">
								<span class="info-label">{{$t('indexFMsg.t13')}}</span>
								<span class="info-value">{{$t('indexFMsg.t14')}} 1cm {{$t('indexFMsg.t15')}}2cm {{$t('indexFMsg.t16')}}3cm</span>
							</div> -->
						</div>
					</div>
				</div>
		
				<!-- Tab 切换栏 -->
				<div class="tab-nav">
					<div
						v-for="(tab, index) in tabs"
						:key="tab.key"
						class="tab-item"
						:class="{ active: activeTab === tab.key }"
						@click="activeTab = tab.key">
						<span v-if="tab.key=='standard'">{{ $t('indexFMsg.t25') }}</span>
						<span v-if="tab.key=='notice'">{{ $t('indexFMsg.t23') }}</span>
						<span v-if="tab.key=='items'">{{ $t('indexFMsg.t24') }}</span>
						<el-image
							v-if="activeTab === tab.key"
							class="tab-active-icon"
							:src="require('@/static/CodeBuddyAssets/31138_2344/6.svg')"
						></el-image>
					</div>
				</div>
		
				<!-- 内容区（带切换动画） -->
				<transition name="tab-content" mode="out-in" @after-enter="onAnimEnd" @before-enter="onAnimStart">
					
					<!-- 报价标准内容 -->
					<div v-if="activeTab === 'standard'" key="standard" class="tab-panel">
						<div class="price-standard-section">
							<!-- 计费标准卡片 -->
							<div class="price-card">
								<div class="card-header">
									<span class="card-title">{{pmsg.name}}</span>
									<span class="card-subtitle">({{$t('indexFMsg.t17')}})</span>
								</div>
								<div class="price-list">
									<div class="price-row" v-for="(item,index) in pmsg.priceList">
										<span class="price-label" v-if="item.type==0">{{$t('indexFMsg.t18')}}({{item.unitWeight}}kg)</span>
										<span class="price-label" v-if="item.type==1">{{$t('indexFMsg.t19')}}</span>
										<span class="price-val">￥{{item.price}}/{{item.unitWeight}}KG</span>
									</div>
								</div>
								<div class="max-weight">{{$t('indexFMsg.t20')}}{{pmsg.maxWeight}}kg</div>
							</div>
							<!-- 渠道规则限制 -->
							<div class="rule-card">
								<div class="rule-title">{{$t('indexFMsg.t21')}}</div>
								<div class="rule-list">
									<p class="rule-text">{{pmsg.channelRules||$t('indexFMsg.t22')}}</p>
								</div>
							</div>
						</div>
					</div>
		
					<!-- 注意事项内容 -->
					<div v-else-if="activeTab === 'notice'" key="notice" class="tab-panel">
						<div class="notice-content">
							<div class="notice-title">{{$t('indexFMsg.t23')}}</div>
							<div class="notice-text">
								<p class="rule-text">{{pmsg.mattersNeedAttention}}</p>
							</div>
						</div>
					</div>
		
					<!-- 可寄物品内容 -->
					<div v-else-if="activeTab === 'items'" key="items" class="tab-panel">
						<div class="items-content">
							<div class="items-title">{{$t('indexFMsg.t24')}}</div>
							<div class="notice-text">
								<p v-for="(itm,idx) in pmsg.supportGoodsTypeName">
									{{itm}}
									<span v-if="idx != pmsg.supportGoodsTypeName.length-1">；</span>
								</p>
							</div>
						</div>
					</div>
					
				</transition>
			</div>
		</div>
		
	</div>
</template>

<script>
import {
	transportLinelineDetail,
} from "/src/api/api.js"
import newsPageHeader from '@/components/newsPageHeader.vue'
export default {
	name: 'ShopWlmsg',
	components: {
		newsPageHeader
	},
	data() {
		return {
			id:0,
			pmsg:'',
			activeTab: 'standard',
			isAnimating: false,
			tabs: [
				{ key: 'standard', label: '报价标准' },
				{ key: 'notice', label: '注意事项' },
				{ key: 'items', label: '可寄物品' }
			],
		}
	},
	mounted() {
		this.id = this.$route.query.id
		this.transportLinelineDetailF()
	},
	methods: {
		// 运输路线列表
		async transportLinelineDetailF(){
			var res;
			res = await transportLinelineDetail({id:this.id});
			if(res.code==200){
				this.pmsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
.shop-addr-page {
	width: 100%;
	// min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb-bar {
	width: 1460px;
	margin: 0 auto;
	padding: 20px 0;
	padding-top: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.breadcrumb-left {
	display: flex;
	align-items: center;
}
.bc-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.bc-item {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin: 0 4px;
}
.bc-item.bc-active {
	color: #0096FF;
}
.bc-arrow {
	width: 18px;
	height: 18px;
	margin: 0 8px;
}
.breadcrumb-right {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.bc-back-text {
	font-size: 16px;
	color: #0096FF;
	font-weight: 400;
}
.bc-back-icon {
	width: 18px;
	height: 18px;
	margin-left: 6px;
}

/* ===================================================================
   表单卡片
   =================================================================== */
/* ===== 详情卡片 ===== */
.fd-body {
	width: 1460px;
	margin: 20px auto 0;
	padding-bottom: 60px;
}
.detail-card {
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 16px rgba(0,0,0,0.05);
	padding: 32px;
	min-height: 465px;
}

/* ===== 渠道信息栏 ===== */
.channel-info-bar {
	background: #f4f9fe;
	border-radius: 8px;
	// height: 126px;
	padding: 24px 24px;
	padding-bottom: 16px;
	margin-bottom: 10px;
}
.channel-name {
	color: #333;
	font-size: 18px;
	font-family: PingFang SC, sans-serif;
	font-weight: 500;
	margin-bottom: 17px;
}
.info-grid {
	display: flex;
	flex-wrap: wrap;
	// gap: 0 140px;
	.l{
		width: 40%;
		// display: flex;
	}
}
.info-item {
	width: 380px;
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	.info-label {
		color: #999;
		font-size: 14px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
	}
	.info-value {
		color: #333;
		font-size: 14px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
		margin-left: auto;
		text-align: right;
	}
}

/* ===== Tab 导航 ===== */
.tab-nav {
	display: flex;
	align-items: center;
	gap: 48px;
	padding: 10px 10px;
	padding-top: 15px;
	border-bottom: 1px solid transparent;
}
.tab-item {
	position: relative;
	cursor: pointer;
	font-size: 16px;
	font-family: PingFang SC, sans-serif;
	color: #999;
	font-weight: 400;
	padding-bottom: 12px;
	transition: color 0.3s;
	&.active {
		color: #0096FF;
		font-weight: 500;
	}
	&:hover:not(.active) {
		color: #666;
	}
	.tab-active-icon {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 36px;
		height: 3px;
	}
}

/* ===== 内容面板切换动效 ===== */
.tab-content-enter-active,
.tab-content-leave-active {
	transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
	            transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
	transform-origin: top center;
}
.tab-content-enter {
	opacity: 0;
	transform: translateY(12px);
}
.tab-content-leave-to {
	opacity: 0;
	transform: translateY(-12px);
}
/* 减少动态偏好 */
@media (prefers-reduced-motion: reduce) {
	.tab-content-enter-active,
	.tab-content-leave-active {
		transition: none;
	}
	.tab-content-enter,
	.tab-content-leave-to {
		opacity: 1;
		transform: none;
	}
}

/* ===== Tab 面板通用 ===== */
.tab-panel {
	animation: fadeInUp 0.35s ease-out both;
}
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(12px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* ========== 报价标准内容 ========== */
.price-standard-section {
	display: flex;
	gap: 28px;
	margin-top: 16px;
}
.price-card {
	width: 537px;
	border: 1px solid #EEE;
	border-radius: 8px;
	padding: 24px;
	.card-header {
		margin-bottom: 22px;
		.card-title {
			color: #333;
			font-size: 18px;
			font-family: PingFang SC, sans-serif;
			font-weight: 500;
		}
		.card-subtitle {
			color: #999;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			margin-left: 8px;
		}
	}
	.price-list {
		margin-bottom: 16px;
	}
	.price-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		&:last-child { margin-bottom: 0; }
		.price-label {
			color: #999;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
		}
		.price-val {
			color: #333;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
		}
	}
	.max-weight {
		color: #333;
		font-size: 14px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
	}
}
.rule-card {
	flex: 1;
	background: #FAFCFE;
	border: 1px solid #EEE;
	border-radius: 8px;
	padding: 24px;
	.rule-title {
		color: #333;
		font-size: 18px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin-bottom: 13px;
	}
	.rule-list {
		.rule-text, .rule-note {
			color: #333;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			line-height: 1.7;
			margin: 0 0 8px;
		}
		.rule-note {
			margin-bottom: 0;
		}
	}
}

/* ========== 注意事项内容 ========== */
.notice-content {
	margin-top: 16px;
	background: #FAFCFE;
	border: 1px solid #EEE;
	border-radius: 8px;
	padding: 24px;
	min-height: 205px;
	.notice-title {
		color: #333;
		font-size: 18px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin-bottom: 19px;
	}
	.notice-text {
		p {
			color: #333;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			line-height: 1.8;
			margin: 0 0 4px;
		}
	}
}

/* ========== 可寄物品内容 ========== */
.items-content {
	margin-top: 16px;
	background: #FAFCFE;
	border: 1px solid #EEE;
	border-radius: 8px;
	padding: 24px;
	min-height: 205px;
	.items-title {
		color: #333;
		font-size: 18px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin-bottom: 19px;
	}
	.notice-text {
		p {
			color: #333;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			line-height: 1.8;
			margin: 0 0 4px;
		}
	}
	.items-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 12px 16px;
		.item-tag {
			display: inline-block;
			padding: 6px 16px;
			background: #fff;
			border: 1px solid #E2E6E9;
			border-radius: 4px;
			color: #333;
			font-size: 14px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			transition: all 0.25s;
			&:hover {
				border-color: #0096FF;
				color: #0096FF;
				box-shadow: 0 2px 8px rgba(0,150,255,0.12);
			}
		}
	}
}

/* ===== Footer ===== */
.fd-footer {
	position: relative;
	width: 100%;
	height: 446px;
	background: #22293C;
	margin-top: 80px;
	overflow: hidden;
}
.footer-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 446px;
	object-fit: cover;
}
.footer-inner {
	position: relative;
	z-index: 1;
	width: 1346px;
	margin: 0 auto;
	padding: 63px 0 0;
}
.footer-links {
	display: flex;
	gap: 72px;
	padding-bottom: 42px;
	border-bottom: 1px solid rgba(230,232,237,0.3);
}
.link-col {
	display: flex;
	flex-direction: column;
	gap: 16px;
	&.wide { min-width: 200px; }
	.col-title {
		color: #fff;
		font-size: 16px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin-bottom: 4px;
	}
	.col-link {
		color: #fff;
		font-size: 13px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
		text-decoration: none;
		transition: color 0.3s;
		&:hover { color: #0096FF; }
	}
}
.footer-contact {
	display: flex;
	justify-content: flex-end;
	margin-top: -110px;
	padding-bottom: 27px;
}
.contact-info {
	text-align: left;
	.contact-title {
		color: #fff;
		font-size: 16px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
	}
	.contact-desc {
		color: #9AA2B1;
		font-size: 13px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin: 30px 0 0;
	}
	.qr-code {
		width: 80px;
		height: 80px;
		margin-top: 8px;
		display: block;
	}
	.contact-phone {
		color: #fff;
		font-size: 13px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		margin-top: 26px;
	}
	.contact-btn {
		width: 196px;
		height: 36px;
		background: #0096FF;
		border-radius: 0;
		color: #fff;
		font-size: 14px;
		font-family: PingFang SC, sans-serif;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10px;
		cursor: pointer;
		transition: background 0.3s;
		&:hover { background: #33ABFF; }
	}
}
.footer-bottom {
	.friend-links {
		margin-bottom: 14px;
		span, a {
			color: #999;
			font-size: 12px;
			font-family: PingFang SC, sans-serif;
			font-weight: 400;
			text-decoration: none;
			margin-right: 12px;
			&:hover { color: #fff; }
		}
	}
	.copy-gray {
		color: #999;
		font-size: 12px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
	}
	.copy-white {
		color: #fff;
		font-size: 12px;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
	}
}
</style>
